import { bluePaletteDark, grayPaletteDark, royalBluePaletteDark } from '../../../themes/dark-colors';
import { ISelectTheme } from './theme';

export const selectDarkTheme: ISelectTheme = {
  variants: {
    primary: {
      valueContainer: {
        textColor: royalBluePaletteDark[1000],
      },
      placeholder: {
        textColor: grayPaletteDark[700],
      },
      focused: {
        borderColor: royalBluePaletteDark[1000],
        shadowColor: royalBluePaletteDark[1000],
        shadowSpread: 10,
      },
      hover: {
        borderColor: bluePaletteDark[700],
      },
      menu: {
        textColor: royalBluePaletteDark[1000],
        borderColor: grayPaletteDark[300],
        backgroundColor: grayPaletteDark[100],
        focusedOption: {
          backgroundColor: grayPaletteDark[300],
        },
        selectedOption: {
          backgroundColor: bluePaletteDark[300],
        },
        group: {
          borderColor: grayPaletteDark[300],
          textColor: royalBluePaletteDark[1000],
        },
        empty: {
          textColor: grayPaletteDark[700],
        },
        disabledOption: {
          textColor: grayPaletteDark[500],
        },
      },
      indicator: {
        iconColor: grayPaletteDark[600],
        hover: {
          iconColor: grayPaletteDark[800],
        },
        clear: {
          borderColor: grayPaletteDark[500],
        },
      },
      multiValue: {
        container: {
          borderColor: grayPaletteDark[400],
          backgroundColor: grayPaletteDark[300],
        },
      },
      popoveredSelect: {
        button: {
          backgroundColor: grayPaletteDark[100],
          borderColor: grayPaletteDark[300],
          hover: { borderColor: bluePaletteDark[700] },
        },
      },
    },
    secondary: {
      valueContainer: {
        textColor: royalBluePaletteDark[800],
      },
      placeholder: {
        textColor: grayPaletteDark[500],
      },
      focused: {
        borderColor: grayPaletteDark[100],
        shadowColor: grayPaletteDark[0],
        shadowSpread: 10,
      },
      hover: {
        borderColor: bluePaletteDark[700],
      },
      menu: {
        textColor: grayPaletteDark[100],
        borderColor: bluePaletteDark[1000],
        backgroundColor: bluePaletteDark[1000],
        focusedOption: {
          backgroundColor: bluePaletteDark[800],
        },
        selectedOption: {
          backgroundColor: bluePaletteDark[900],
        },
        group: {
          borderColor: bluePaletteDark[900],
          textColor: grayPaletteDark[100],
        },
        empty: {
          textColor: grayPaletteDark[100],
        },
        disabledOption: {
          textColor: grayPaletteDark[800],
        },
      },
      indicator: {
        iconColor: grayPaletteDark[600],
        hover: {
          iconColor: grayPaletteDark[800],
        },
        clear: {
          borderColor: grayPaletteDark[300],
        },
      },
      multiValue: {
        container: {
          borderColor: grayPaletteDark[400],
          backgroundColor: bluePaletteDark[800],
        },
      },
      popoveredSelect: {
        button: {
          backgroundColor: grayPaletteDark[100],
          borderColor: grayPaletteDark[300],
          hover: { borderColor: bluePaletteDark[700] },
        },
      },
    },
  },
};
